'use client';

import { c as _c } from "react/compiler-runtime";
import { pushCookieEvent } from '@/globals/analytics/events/pushCookieEvent';
import { createCookieStringStore, useCookieStore } from '@/globals/webStorage/useCookieStorage';
import { PropsWithChildren, createContext, useCallback, useContext, useMemo } from 'react';
import { CookieConsentState, CookieWidget, acceptCookiesName, cookieConsentOptions, cookieConsentStates } from './CookieConsent.config';
const cookieConsentContext = createContext<[CookieConsentState | null, (state: CookieConsentState, widget: CookieWidget) => void] | undefined>(undefined);
const store = createCookieStringStore(acceptCookiesName, cookieConsentStates, cookieConsentOptions);
export const CookieConsentProviderClient = t0 => {
  const $ = _c(8);
  const {
    children,
    serverValue
  } = t0;
  const [consentState, setConsentState] = useCookieStore(store, "unknown", serverValue);
  let t1;
  if ($[0] !== setConsentState) {
    t1 = (state, widget) => {
      setConsentState(oldState => {
        pushCookieEvent({
          oldCookieConsent: oldState === null ? "unknown" : oldState,
          cookieConsent: state,
          widget
        });
        return state;
      });
    };
    $[0] = setConsentState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setCookieConsentState = t1;
  let t2;
  if ($[2] !== consentState || $[3] !== setCookieConsentState) {
    t2 = [consentState, setCookieConsentState];
    $[2] = consentState;
    $[3] = setCookieConsentState;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = t2;
  let t4;
  if ($[5] !== children || $[6] !== t3) {
    t4 = <cookieConsentContext.Provider value={t3}>{children}</cookieConsentContext.Provider>;
    $[5] = children;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export const useCookieConsent = () => {
  const cookieConsentContextValue = useContext(cookieConsentContext);
  if (cookieConsentContextValue == null) {
    throw new Error("No cookie consent context found");
  }
  return cookieConsentContextValue;
};